import React from 'react';
import { UIText3 } from '@cian/ui-kit';

import { useMessageContext } from '../../../../utils/messageContext';
import { ERequestApiStatus } from '../../../../types/appState';

export const ErrorTextContainer: React.FC = () => {
  const { message } = useMessageContext();
  const { status } = message;

  if (status !== ERequestApiStatus.Failed) {
    return null;
  }

  return <UIText3 color="text-negative-default">не отправлено</UIText3>;
};
